<template>
  <div class="customer-cell-container">
    <span class="customer-name">
      {{ props.model.customer.first_name }} {{ props.model.customer.last_name }}
    </span>
    <span class="customer-phone">
      {{ props.model.customer.phone }}
    </span>
  </div>
</template>



<script lang="ts" setup>

import { defineProps, ref, inject } from 'vue';
import type { ColumnDataSchemaModel } from '@revolist/vue3-datagrid';

const props = defineProps<ColumnDataSchemaModel>();
const CustomerCell = ref<HTMLElement>();

console.log('CustomerCell props:', props);
console.log('CustomerCell model:', props.model);

const message = inject('sample');
function customCellClickEvent() {
  console.log('Custom cell click > Injected message:', message);
  const event = new CustomEvent('cell-custom-action', {
      bubbles: true,
      detail: { row: props.model },
  });
  CustomerCell.value?.dispatchEvent(event);
}
</script>

<style scoped>
.customer-cell-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
}

.customer-name {
  font-weight: 600;
  color: #22223b;
  line-height: 1.2;
}

.customer-phone {
  font-size: 0.92rem;
  color: #6c6c80;
  line-height: 1.2;
}
</style>